import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { UnifiedSurveyManagement } from './components/UnifiedSurveyManagement';
import { SurveyBuilder } from '../question';

const SurveyRoutes: React.FC = () => {
  return (
    <Routes>
      {/* Main surveys page - shows all surveys for lecturer's current subject */}
      <Route index element={<UnifiedSurveyManagement />} />

      {/* Survey question builder - edit questions for a specific survey */}
      <Route path=":surveyId/questions" element={<SurveyBuilder />} />

      {/* Template question builder - edit questions for a template */}
      <Route path="templates/:templateId/questions" element={<SurveyBuilder />} />

      {/* Redirect any other paths to the main surveys page */}
      <Route path="*" element={<Navigate to="/app/surveys" replace />} />
    </Routes>
  );
};

export default SurveyRoutes;
